import { useCallback } from "react";
import { SimulationFormParams } from "../types/forms";
import { useMode } from "../mode/ModeContext";

/**
 * Hook that returns a persist function.
 * Delegates to ModeContext's persistSession (auto-save to history).
 */
export function useStatePersistence() {
  const { persistSession } = useMode();

  const persist = useCallback(
    (simulations: SimulationFormParams[]) => {
      persistSession(simulations);
    },
    [persistSession],
  );

  return persist;
}
